/* eslint-disable */

const mixin = {
  data() {
    return {
      visible: false,
      escapeKey: true,
      onClose: () => {},
      resolve: null,
      reject: null
    }
  },
  methods: {
    popupReturn() {
      return new Promise((resolve, reject) => {
        this.resolve = (...value) => {
          resolve(...value)
          this.close()
        }
        // next
        this.reject = (...value) => {
          reject(...value)
          this.close()
        }
      })
    },
    close() {
      this.closed = true
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    keydown(e) {
      if (e.keyCode === 27) this.close()
    }
  },
  mounted() {
    if (!this.escapeKey) return
    document.addEventListener('keydown', this.keydown)
  },
  beforeDestroy() {
    if (!this.escapeKey) return
    document.removeEventListener('keydown', this.keydown)
  }
}

export default mixin



// WEBPACK FOOTER //
// ./src/modules/dialog-builder/mixin.js